// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"b17ebdc7","408":"9929a9ab","435":"5f8d7d6f","453":"ac38ab94","875":"15ce6013"}[chunkId] + ".chunk.js";
};